<template>
    <div class="componentWrapper">
        <div class="imageContainer">
            <img 
                :src="require('../../assets/shopLanding/sections/renderedImagesTemp.png')" 
                alt=""
            >
            <img 
                class="ringsImg"
                :src="require('../../assets/shopLanding/sections/illustrationRings.svg')" 
                alt=""
            >
        </div>
        <div class="texts">
            <span>{{ $t('textSection.smallTitle', currentLang) }}</span>
            <h1>{{ $t('textSection.title', currentLang) }}</h1>
            <p v-html="$t('textSection.text', currentLang)"></p>
            <div class="footer">
                <!-- <i class="pi pi-star-fill"></i> -->
                <!-- <h1>{{ $t('textSection.footerText', currentLang) }}</h1> -->
            </div>
            <div class="sectionBtns">
                <!-- <Button 
                    style="height: 60px; font-family: 'Space Grotesk', Sans-serif; font-size: 18px; font-weight: 500; letter-spacing: 0.5; padding-left: 0px; padding-right: 15px; color: steelblue" 
                    :label="$t('buttons.references', currentLang)" 
                    @click="$router.push({ name: 'referencesPage' })" 
                    icon="pi pi-hammer" 
                    text 
                    severity="secondary"  
                /> -->
                <Button 
                    style="height: 60px; font-family: 'Space Grotesk', Sans-serif; font-size: 18px; font-weight: 500; letter-spacing: 0.5; padding-left: 15px; padding-right: 15px; background-color: steelblue; border: 1px solid steelblue;" 
                    :label="$t('buttons.contactUs', currentLang)" 
                    @click="$emit('openContactPopup')" 
                    icon="pi pi-phone" 
                    severity="contrast"  
                />
                <!-- <Button 
                    style="height: 60px; font-family: 'Space Grotesk', Sans-serif; font-size: 18px; font-weight: 500; letter-spacing: 0.5; padding-left: 15px; padding-right: 0px; color: steelblue" 
                    :label="$t('buttons.shop', currentLang)" 
                    @click="$router.push({ name: 'catalogPage' })" 
                    icon="pi pi-shopping-cart" 
                    text 
                    severity="secondary"  
                /> -->
            </div>
        </div>
    </div>
</template>
  
<script>
import Button from 'primevue/button';
export default {
    name: 'textSection',
    components: {
        Button
    },
    data() {
        return {
        };
    },
    computed: {
        currentLang() {
            return this.$route.params.lang || 'et'; // Default to 'et' if no lang param
        }
    },
    methods: {
        
    },
    created() {
        

    },
    mounted() {
      // Lifecycle hook - called after the component is mounted to the DOM
    
    },
    updated() {
      // Lifecycle hook - called after a data change causes the DOM to re-render
    
    },
  };
</script>

<style scoped>
.componentWrapper {
    position: relative;
    width: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between
}
.imageContainer {
    position: relative;
    z-index: 1;
    margin-top: 97px;
    background: #EFF1F3;
    width: 550px;
    height: 390px;
    border-radius: 25px;
    /* box-shadow: 4px 9px 10px 0px rgba(0,0,0,0.2);
    border: 1px solid rgb(232, 232, 232); */
}
.imageContainer img:first-child {
    position: absolute;
    z-index: 1;
    bottom: 0;
    width: 600px;
    margin-bottom: 0px;
    border-radius: 25px;
}
.ringsImg {
    position: absolute;
    z-index: 0;
    top: -150px;
    right: 260px;
    width: 450px;
    margin-bottom: 0px;
    border-radius: 25px;
}
.texts {
    width: 40%;
    margin-top: 0px;
}
.texts h1 {
    margin-top: 10px;
}
.texts p {
    color: rgb(125, 125, 125);
    color: #3a5a75;
    font-size: 18px;
    margin-bottom: 5px;
}
.texts span {
    font-family: "Inter", sans-serif;
    color: #94a2b9;
    font-weight: 700;
}
.footer {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    padding-bottom: 10px;
    margin-bottom: 20px;
    border-bottom: 1px solid rgb(230, 230, 230);
}
.footer i {
    height: -webkit-fit-content;
    height: -moz-fit-content;
    height: fit-content;
    font-size: 55px;
    margin-top: auto;
    margin-bottom: auto;
    margin-right: 25px;
    color: rgb(168, 161, 147);
}
.footer h1 {
    margin-top: 20px;
    font-size: 24px;
    line-height: 30px;
    color: rgb(168, 161, 147);
}
.sectionBtns {
    display: flex;
    justify-content: space-between;
}
@media (max-width: 1100px) {
    .componentWrapper {
        flex-direction: column;
    }
    .imageContainer {
        order: 1;
        margin: 0 auto;
        margin-top: 150px;
    }
    .texts {
        width: 100%;
        order: 0;
    }
}
@media (max-width: 675px) {
    .imageContainer {
        width: 100%;
        
    }
    .imageContainer img:first-child {
        width: 100%;
    }
}
@media (max-width: 500px) {
    .imageContainer {
        width: 100%;
        margin-top: 130px;
        height: 250px;
    }
    .texts h1 {
        font-size: 8vw;
    }
    .footer h1 {
        font-size: 6vw;
    }
    .sectionBtns {
        display: none;
    }
}
@media (max-width: 450px) {
    .imageContainer {
        margin-top: 40px;
        height: 250px;
    }
    .texts h1 {
        font-size: 8vw;
    }
    .footer h1 {
        font-size: 6vw;
    }
}
</style>